export default "__VITE_ASSET__BsC$70Ma__"